import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';

import {
	Ionicons,
	FontAwesome,
	Foundation,
	SimpleLineIcons,
	MaterialCommunityIcons,
	Entypo,
	Feather,
	MaterialIcons,
} from '@expo/vector-icons';

const icons = {
	exclamation: [FontAwesome, 'exclamation'],
	numberedList: [Foundation, 'list-number'],
	note: [SimpleLineIcons, 'note'],
	ticket: [FontAwesome, 'ticket'],
	dollar: [Foundation, 'dollar'],
	coins: [MaterialCommunityIcons, 'coins'],
	signal: [Entypo, 'signal'],
	exclamationCircle: [SimpleLineIcons, 'exclamation'],
	locationPin: [SimpleLineIcons, 'location-pin'],
	machine: [Entypo, 'text-document'],
	refresh: [Ionicons, 'refresh'],
	map: [Entypo, 'map'],
	directions: [SimpleLineIcons, 'directions'],
	moreVertical: [Feather, 'more-vertical'],
	moreHorizontal: [Feather, 'more-horizontal'],
	key: [Ionicons, 'key'],
	close: [FontAwesome, 'close'],
	calendar: [Ionicons, 'calendar'],
	torso: [FontAwesome, 'user'],
	check: [FontAwesome, 'check'],
	user: [FontAwesome, 'user'],
	lock: [FontAwesome, 'lock'],
	clock: [SimpleLineIcons, 'clock'],
	star: [FontAwesome, 'star-o'],
	starSolid: [FontAwesome, 'star'],
	arrowRight: [MaterialIcons, 'keyboard-arrow-right'],
	arrowDropDown: [MaterialIcons, 'arrow-drop-down'],
	arrowDropUp: [MaterialIcons, 'arrow-drop-up'],

	grid: [FontAwesome, 'th'],
	list: [FontAwesome, 'list'],
	voice: [FontAwesome, 'volume-up'],
	copy: [MaterialCommunityIcons, 'content-copy'],
	camera: [Feather, 'camera'],
	truck: [FontAwesome, 'truck'],
	print: [FontAwesome, 'print'],
};

const Icon = ({
	name,
	onPress,
	style,
	...otherProps
}) => {
	if (icons[name]) {
		const icon = React.createElement(icons[name][0], {
			name: icons[name][1],
			color: '#CCC',
			size: 24,
			style,
			...otherProps,
		});

		if (onPress) {
			return (
				<TouchableOpacity onPress={onPress}>
					{icon}
				</TouchableOpacity>
			);
		}

		return (
			<View>
				{icon}
			</View>
		);
	}

	return <Text>Icon not found</Text>;
};

export default Icon;
